export default __webpack_public_path__ + "static/media/9f1ad63efb8e2a0c84cb60f496c2c183.jpg";